import * as React from "react";

import { Comment } from "Stores/dashboardStore/comments";
import { Utils } from "../../common/utils";

import { Button, Spinner } from "react-bootstrap";
import TipTapEditor from "Components/Common/TheEditor";
import { draftToProseMirrorJSON, safeJsonParse } from "@/lib/convertDraftToProseMirror";

interface CommentFormProps {
    handleCancel: () => void
    handleSave: ({ comment, formatted_comment}: CommentFormState) => void
    isProcessing?: boolean
    currentComment?: Comment
}

interface CommentFormState {
    comment: string
    formatted_comment: string
}

export class TicketCommentForm extends React.Component<CommentFormProps, CommentFormState> {

    state = {
        formatted_comment: this.props.currentComment ? this.props.currentComment.formatted_comment : "",
        comment: this.props.currentComment ? this.props.currentComment.comment : ""
    };

    parsedComment = this.props.currentComment && safeJsonParse(this.props.currentComment.formatted_comment);

    commentContent = this.parsedComment && this.parsedComment.type === "doc" 
        ? this.parsedComment
        : this.parsedComment && this.parsedComment.blocks 
            ? draftToProseMirrorJSON(this.parsedComment as any)
            : this.parsedComment;

    handleSave = () => {
        this.props.handleSave({
            formatted_comment: this.state.formatted_comment,
            comment: this.state.comment
        });
    };

    handleCancel = () => {
        this.props.handleCancel();
    };

    handleChange = (formatted_comment: string) => {
        this.setState({ formatted_comment });
    };

    componentDidMount(){
        Utils.pushViewName("CommentView");
    }

    componentWillUnmount(){
        Utils.popViewName();
    }

    render(){
        return (
            <div className="comment-edit" style={ {paddingBottom: 10, width: "100%"} }>
                <TipTapEditor id="comment-form-edit" value={this.commentContent} editable={!this.props.isProcessing} onChange={this.handleChange} onGetPlainText={(content) => this.setState({ comment: content })} />
                <div className="small-actions" style={ {paddingTop: 10} }>
                    <Button
                        variant="secondary"
                        id="cqi-comment-form-cancel"
                        onClick={ this.handleCancel }
                        disabled={ this.props.isProcessing }>
                        Cancel
                    </Button>
                    <Button
                        variant="primary"
                        id="cqi-comment-form-submit"
                        disabled={ !this.state.formatted_comment || this.state.formatted_comment === "" || this.props.isProcessing }
                        onClick={ this.handleSave }>
                        { this.props.isProcessing
                            ? <Spinner variant={"secondary"} animation={"border"} size={ "sm" }/>
                            : "save"
                        }
                    </Button>
                </div>
            </div>
        );
    }
}
